import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { PopupService } from 'src/app/shared/service/popup.service';

@Injectable({
  providedIn: 'root',
})
export class WheelService {
  constructor(private popup: PopupService, private router: Router) {}

  open() {
    import('src/app/pages/activity/new-wheel/new-wheel.component').then(({ NewWheelComponent }) => {
      this.popup
        .open(NewWheelComponent)
        .afterClosed()
        .subscribe(_ => {
          this.router.navigate([], { replaceUrl: true });
        });
    });
  }
}
